import React, { type FC } from 'react';
import clsx from 'clsx';
import Loader from 'components/Loader';
import styles from './Button.module.scss';

export enum ButtonVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Gradient = 'Gradient',
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  variant?: ButtonVariant;
  loading?: boolean;
  inactive?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
}

const Button: FC<ButtonProps> = ({
  variant = ButtonVariant.Primary,
  title,
  type = 'button',
  inactive,
  className,
  onClick,
  loading,
}) => {
  const getButtonClasses = () => {
    const primary = variant === ButtonVariant.Primary;
    const secondary = variant === ButtonVariant.Secondary;
    const gradient = variant === ButtonVariant.Gradient;

    return clsx(
      {
        [styles.primaryButton]: primary,
        [styles.primaryDisabled]: primary && inactive,
        [styles.secondaryButton]: secondary,
        [styles.secondaryDisabled]: secondary && inactive,
        [styles.gradientButton]: gradient,
        [styles.gradientDisabled]: gradient && inactive,
      },
      loading && styles.loadingButton,
      styles.button,
      className,
    );
  };

  return (
    <button
      type={type}
      className={getButtonClasses()}
      disabled={loading || inactive}
      onClick={onClick}
    >
      {loading ? <Loader /> : title}
    </button>
  );
};

export default Button;
